import { PropsWithChildren } from 'react';

import LeftOutlinedIcon from '@ant-design/icons/LeftOutlined';
import RightOutlinedIcon from '@ant-design/icons/RightOutlined';
import { css } from '@emotion/css';
import { Carousel } from 'antd';

const carouselStyle = (height: number) => css`
  height: ${height}px;

  .slick-prev,
  .slick-prev:focus,
  .slick-prev:hover {
    left: 5px;
    z-index: 2;
    color: black;
    font-size: 20px;
  }

  .slick-next,
  .slick-next:focus,
  .slick-next:hover {
    right: 5px;
    z-index: 2;
    color: black;
    font-size: 20px;
  }

  .slick-prev::before,
  .slick-next::before {
    content: none;
  }
`;

const dotsStyle = css`
  bottom: 0px !important;

  li button {
    background-color: black !important;
  }

  li.slick-active button {
    background-color: black !important;
  }
`;

interface MCarouselProps {
  afterChange?: (currentSlide: number) => void;
  height?: number;
}

export const MCarousel = ({ afterChange, height = 300, children }: PropsWithChildren<MCarouselProps>) => {
  return (
    <Carousel
      arrows
      afterChange={afterChange}
      prevArrow={
        <div>
          <LeftOutlinedIcon />
        </div>
      }
      nextArrow={
        <div>
          <RightOutlinedIcon />
        </div>
      }
      effect='fade'
      className={carouselStyle(height)}
      dots={{
        className: dotsStyle,
      }}>
      {children}
    </Carousel>
  );
};
